<template>
  <v-card
    style="height: 100%"
    class=""
  >
    <v-card-title class="text-capitalize">{{ $t("Séances") }}
    <v-spacer />
      <v-btn
        icon
        small
        color="primary"
      >
        <v-icon
          color="primary"
          @click="openDialog({})"
        >
          {{ icons.mdiPlus }}
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="text--primary overflow-y-auto" style="max-height: 250px">
      <p v-if="!(author.author_sessions || []).length">{{ $t("Aucun séances renseigné") }}</p>
      <div v-for="it in author.author_sessions" :key="it.id">
        <div
          class="d-flex justify-space-between align-center"
        >
          <div>
            <div class="bold">
              {{ it.label }}
            </div>
            <div class="body-2 d-flex flex justify-space-between">
              <span class="mr-3">Lieu : {{ it.location || '' }}</span>
              <span>{{ formatDate(it.date) }}</span>
            </div>
          </div>
          <div class="text--primary font-weight-semibold ml-2">


            <v-btn
              icon
              x-small
              color="error"
            >
              <v-icon
                small
                color="info"
                @click="openDialog(it)"
              >
                {{ icons.mdiPencilOutline }}
              </v-icon>
            </v-btn>
            <v-btn
              icon
              x-small
              color="error"
            >
              <v-icon
                small
                color="error"
                @click="openDeleteDialog(it)"
              >
                {{ icons.mdiDeleteOutline }}
              </v-icon>
            </v-btn>
          </div>
        </div>
        <v-divider />
      </div>
    </v-card-text>
    <v-dialog
      v-model="isFormActive"
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 300 : '100%'"
    >
      <v-form
        ref="form"
        v-model="valid"
        @submit.prevent="onSubmit"
      >
        <v-card
          height="100%"
          flat
        >
          <v-card-title>
            <span class="font-weight-semibold text-base text--primary">{{ item && item.id?$t('Modifier'):$t("Ajouter une séance") }}</span>
            <v-spacer />
            <v-spacer></v-spacer>
            <v-btn
              icon
              small
              color="error"
              @click="isFormActive = false"
            >
              <v-icon size="22">
                {{ icons.mdiClose }}
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-divider />
          <v-card-text
            class="overflow-y-auto"
            style="max-height: 700px;"
          >
            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="item.label"
                  outlined
                  dense
                  :label="$t('Enseigne')"
                  :placeholder="$t('Enseigne')"
                  :error-messages="errorMessages.label"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="item.location"
                  outlined
                  dense
                  :label="$t('Lieu de la séance')"
                  :placeholder="$t('Lieu de la séance')"
                  :error-messages="errorMessages.label"
                  hide-details="auto"
                  :prepend-inner-icon="icons.mdiMapMarkerOutline"
                ></v-text-field>
              </v-col>


<!--              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="item.participants"
                  outlined
                  dense
                  :label="$t('Nombre de participants')"
                  :placeholder="$t('Nombre de participants')"
                  :error-messages="errorMessages.participants"
                  hide-details="auto"
                  type="number"
                ></v-text-field>
              </v-col>-->
              <v-col
                cols="12"
              >
                <date-picker
                  v-model="item.date"
                  outlined
                  dense
                  :label="$t('Date')"
                  :placeholder="$t('Date')"
                  :error-messages="errorMessages.date"
                  hide-details="auto"
                ></date-picker>
              </v-col>
<!--              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="item.link"
                  outlined
                  dense
                  :label="$t('Lien vers le compte')"
                  :placeholder="$t('Lien vers le compte')"
                  :error-messages="errorMessages.link"
                  hide-details="auto"
                ></v-text-field>
              </v-col>-->
<!--              <v-col
                cols="12"
                sm="6"
              >
                <v-switch
                  v-model="item.status"
                  :label="$t('État de la communauté')"
                  :true-value="1"
                  :false-value="0"
                ></v-switch>
              </v-col>-->
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn
              :loading="loading"
              color="secondary"
              outlined
              type="reset"
              @click="resetItem"
            >
              {{ $t('Annuler') }}
            </v-btn>
            <v-spacer />
            <v-btn
              :loading="loading"
              color="primary"
              class="me-3"
              type="submit"
            >
              {{ $t("Enregistrer") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog
      v-model="isDeleteFormActive"
      touchless
      :right="!$vuetify.rtl"
      width="400"
    >
      <v-card
        height="100%"
        flat
      >
        <v-card-title>
          <span class="font-weight-semibold text-base text--primary">{{ $t("Confirmer la suppression") }}</span>
          <v-spacer />
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            color="error"
            @click="isDeleteFormActive = false"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text
          class="overflow-y-auto"
          style="max-height: 700px;"
        >
          <p class="text-center">
            {{ $t("Êtes-vous sûr de vouloir supprimer cet élément ?") }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :loading="deleting"
            color="secondary"
            outlined
            type="reset"
            @click="isDeleteFormActive = false"
          >
            {{ $t('Annuler') }}
          </v-btn>
          <v-spacer />
          <v-btn
            :loading="deleting"
            color="primary"
            class="me-3"
            @click="deleteItem"
          >
            {{ $t("Continue") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="isSnackbarBottomVisible"
      :color="$vuetify.theme.currentTheme.error"
      :light="$vuetify.theme.dark"
    >
      {{ snackBarMessage }}
    </v-snackbar>
  </v-card>
</template>

<script>
import {
  mdiClose, mdiPencilOutline, mdiPencilOffOutline, mdiDeleteOutline, mdiPlus,mdiMapMarkerOutline
} from '@mdi/js'
import { computed, onUnmounted, ref } from '@vue/composition-api'
import { required, emailValidator } from '@core/utils/validation'
import { avatarText, formatDate } from '@core/utils/filter'
import axios from '@axios'
import countries from '@/@fake-db/data/other/countries'
import store from '@/store'
import DatePicker from "@/components/DatePicker.vue";

/* import useAuthorsList from './useAuthorsList'
import FileUpload from '@/components/file_upload'
import Addresses from '@/views/apps/author/author-list/Addresses'
import authorStoreModule from '@/views/apps/author/authorStoreModule'
import AuthorForm from "@/views/apps/author/author-list/AuthorForm.vue"; */

export default {
  components: {
    DatePicker
  },
  model: {
    prop: 'object',
  },
  props: {
    object: {
      type: Object,
      default: () => {},
    },
  },
  methods: { formatDate },
  setup(props, { emit }) {
    const errorMessages = ref({ })
    const valid = ref(false)
    const loading = ref(false)
    const deleting = ref(false)
    const item = ref({})
    const isFormActive = ref(false)
    const isDeleteFormActive = ref(false)
    const form = ref(null)
    const isSnackbarBottomVisible = ref(false)
    const snackBarMessage = ref('')
    const validate = () => {
      form.value.validate()
    }

    const author = computed({
      get: () => props.object,
      set: value => emit('object', value),
    })
    author.value.author_sessions = author.value.author_sessions || []

    // const item = ref(JSON.parse(JSON.stringify(blankItem)))
    const resetItem = () => {
      // item.value = {}
      // resetForm()

      isFormActive.value = false
    }
    const deleteItem = () => {
      if (!item.value.id) author.value.author_sessions.splice(author.value.author_sessions.findIndex(e => e.id === item.value.id), 1)
      deleting.value = true
      axios.delete(`/author/${author.value.id}/sessions/${item.value.id}`).then(response => {
        isDeleteFormActive.value = false
        deleting.value = false
        emit('object', response.data)
       // author.value = response.data
       emit('refresh-data')


      }).then(() => {
        isDeleteFormActive.value = false
        deleting.value = false
      })
    }
    const openDialog = it => {
      item.value = it || {}

      isFormActive.value = true
    }
    const openDeleteDialog = it => {
      item.value = it || {}
      deleting.value = false
      isDeleteFormActive.value = true
    }

    const onSubmit = () => {
      if (!item.value.label) {
        isSnackbarBottomVisible.value = true
        snackBarMessage.value = 'Veuillez saisir un nom d\'événement.'

        return
      }
      if (valid.value) {
        loading.value = true
        console.log('saving session', item.value)
        axios.post(`author/${author.value.id}/sessions`, item.value)
          .then(response => {
            loading.value = false
            isFormActive.value = false
            if (response.data.error || response.data.errors || (response.data.status && response.data.status === 'false')) {
              if (response.data.errors) {
                // this.toast(this.$t('These credentials do not match our records'), this.$vuetify.theme.currentTheme.error)
                errorMessages.value = { ...response.data.errors }
              } else {
                isSnackbarBottomVisible.value = true
                snackBarMessage.value = response.data.message

                // this.toast(response.data.message, this.$vuetify.theme.currentTheme.error)
              }

              return false
            }

            // resetItem()
            emit('object', response.data)
            //author.value = response.data
            emit('refresh-data')

            // emit('update:is-form-active', false)
          }).catch(() => {
            loading.value = false
            isFormActive.value = false
          }).catch(error => {
            loading.value = false
            isFormActive.value = false
            console.log('error', error)
            if (error.data.errors) {
            // this.toast(this.$t('These credentials do not match our records'), this.$vuetify.theme.currentTheme.error)
              errorMessages.value = { ...error.data.errors }
            }
          })
      } else {
        validate()
      }
    }

    // eslint-disable-next-line no-unused-vars
    /* watch(() => props.object, (newValue, prevValue) => {
      if (!newValue || !newValue.id) {
        resetItem()
      } else {
        item.value = JSON.parse(JSON.stringify(newValue))
      }
    }) */
    // eslint-disable-next-line no-unused-vars
    /* watch(() => item, (newValue, prevValue) => {
      console.log('item change', newValue.value)
      emit('input', newValue.value)
    }, { deep: true }) */

    /* store
      .dispatch('app/fetchNetworks', { per_page: 500 }) */

    return {
      openDialog,
      openDeleteDialog,
      resetItem,
      deleteItem,
      form,
      loading,
      deleting,
      isFormActive,
      isDeleteFormActive,
      isSnackbarBottomVisible,
      snackBarMessage,
      errorMessages,
      onSubmit,
      countries,
      item,
      author,
      valid,
      validate,
      avatarText,

      // validation
      validators: { required, emailValidator },
      icons: {
        mdiClose,
        mdiPencilOffOutline,
        mdiPencilOutline,
        mdiPlus,
        mdiDeleteOutline,
        mdiMapMarkerOutline
      },
    }
  },
}
</script>
